import { render, staticRenderFns } from "./ShowGrM.vue?vue&type=template&id=50dabffc&scoped=true&"
import script from "./ShowGrM.vue?vue&type=script&lang=js&"
export * from "./ShowGrM.vue?vue&type=script&lang=js&"
import style0 from "./ShowGrM.vue?vue&type=style&index=0&id=50dabffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dabffc",
  null
  
)

component.options.__file = "ShowGrM.vue"
export default component.exports